/**
 * Created by giri@nish
 */
(function() {
    angular
        .module('eAccess.ProviderPortal.Services.ApplicationStartup', []);
})();
